import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initPixel } from './lib/metaPixel';
render(<App data-id="element-267" />, document.getElementById('root'));
setTimeout(() => {
  try {
    initPixel();
  } catch (error) {
    console.warn('Meta Pixel initialization skipped:', error);
  }
}, 300);